<!--
 * @Description: 居民用户配置组件
 * @Author: gaohc
 * @Date: 2022-03-16 16:43:52
-->
<template>
	<div class="resident-usercfg-body">
		<el-row :gutter="45">
			<el-col :span="8">
				<el-card class="box-card" shadow="never" :body-style="{ padding: '0px','background-color': '#FAFBFF',}">
					<div class="box-card-left-main">
						<div class="box-card-header">
							<span style="font-weight: bold">用户关系</span>
							<img src="../../../../assets/hsvccfg/add-plus.png" @click="handleAddUsership" alt="" style="width: 15px; padding-top: 3px; cursor: pointer"  />
						</div>
						<el-table :data="listUsership"  :show-header="false" :highlight-current-row="true"
							:row-class-name="tableRowClassNameOfUsership"
							@cell-mouse-enter="handleMouseEnterUsershipCell"
							@cell-mouse-leave="handleMouseLeaveUsershipCell">
							<el-table-column label="" min-width="60%">
								<template slot-scope="scope">
									<span>{{scope.row.name }}</span>
								</template>
							</el-table-column>
							<el-table-column align="right" min-width="40%">
								<template slot-scope="scope" v-if="indexSelectUsership == scope.row.index">
									<img width="16px" height="16px" class="img-edit mouse-pointer"
										src="@/assets/syscfg/icon-usercfg-edit.png"
										@click="handleEditUsership(scope.$index, scope.row)" alt=""/>
									<img width="16px" height="16px" class="img-delete mouse-pointer"
										src="@/assets/syscfg/icon-usercfg-delete.png"
										@click="handleDeleteUsership(scope.$index, scope.row)" alt=""/>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'ResidentCfg',
		components: {},
		props: ["listUsership"],
		data() {
			return {
				indexSelectUsership: -1, //当前选中的用户关系下标
			}
		},

		methods: {
			tableRowClassNameOfUsership({
				row,
				rowIndex
			}) {
				row.index = rowIndex;
			},

			handleMouseEnterUsershipCell(row, _column, _event) {
				this.indexSelectUsership = row.index;
			},

			handleMouseLeaveUsershipCell(_row, _column, _event) {
				this.indexSelectUsership = -1;
			},

			//新增用户关系
			handleAddUsership() {
				this.$emit("add-usership");
			},

			//编辑用户关系
			handleEditUsership(_index, row) {
				this.$emit("edit-usership", row);
			},
			//删除用户关系
			handleDeleteUsership(_index, row) {
				this.$emit("delete-usership", row);
			}
		}
	}
</script>

<style scoped>
	.body {
		margin: 0;
		text-align: center;
		border: solid 0px;
	}

	.resident-usercfg-body {
		margin: 0;
		text-align: left;
		border: solid 0px;
	}

	.resident-usercfg-body /deep/ .el-table {
		max-height: 260px;
		overflow-y: auto;
		overflow-x: hidden;
		background-color: #FAFBFF;
		min-height: 160px;
	}

	.resident-usercfg-body /deep/ .el-table .el-table__row {
		background-color: #FAFBFF;
	}

	.resident-usercfg-body /deep/ .el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 0;
	}

	.resident-usercfg-body /deep/ .el-table .cell {
		padding-left: 20px;
	}

	.resident-usercfg-body .box-card-header {
		padding: 0 20px;
		height: 45px;
		background-color: white;
		font-size: 15px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.resident-usercfg-body .img-edit {
		margin: 0 15px 0 0;
	}

	.resident-usercfg-body .img-delete {
		margin: 0px 5px 0 0;
	}

	.resident-usercfg-body .tag-color {
		vertical-align: middle;
		width: 33px;
		height: 17px;
		border-width: 0;
	}

	.resident-usercfg-body .tag-text {
		border-width: 0;
		vertical-align: middle;
	}

	.resident-usercfg-body .el-table__row>td {
		border: none;
	}

	.resident-usercfg-body .el-table::before {
		height: 0px;
	}

	.resident-usercfg-body .el-table__empty-block {
		background-color: #FAFBFF;
	}
</style>



// WEBPACK FOOTER //
// src/components/syscfg/components/usercfg/ResidentCfg.vue